import { EditNote } from '@mui/icons-material';
import { Card, Typography } from '@mui/material';
import styled from 'styled-components';

import {
  BaseColorKeys, NotifierColorKeys, SubjectColorKeys,
} from '../../theme';

interface ColorProps {
  $color: BaseColorKeys | SubjectColorKeys | NotifierColorKeys;
}

interface StyledCardProps {
  $selected: boolean;
  $greyedOut: boolean;
}

const StatusContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const BottomContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const StyledCard = styled(Card)<StyledCardProps>`
  && {
    background-color: ${({ theme }) => theme.palette.backdrop.main};
    border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
    outline: ${({ theme, $selected }) => ($selected ? `1.5px solid ${theme.palette.info.main}` : 'none')};
    opacity: ${({ $greyedOut }) => ($greyedOut ? 0.4 : 1)};
  }
`;

const LessonTime = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.gray.main};
  }
`;

const LessonLabel = styled(Typography)<ColorProps>`
  && {
    color: ${({ theme, $color }) => theme.palette[$color].dark};
  }
`;

const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
  justify-content: center;
  align-items: flex-start;
`;

const LessonLabelContainer = styled.div`
display: flex;
flex-direction: column;
gap: ${({ theme }) => theme.spacing(1)};
justify-content: center;
align-items: flex-start;
`;

const HeadingContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

const HeadingTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(3)};
`;

const StyledNoteIcon = styled(EditNote)`
  && {
    color: ${({ theme }) => theme.palette.gray.main};
    vertical-align: middle;
    font-size: 1.5rem;
  }
`;

const LessonNoteTypography = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.gray.main};
    white-space: pre-line;
  }
`;

export { StatusContainer,
  BottomContainer,
  StyledCard,
  LessonTime,
  LessonLabel,
  ProfileContainer,
  TimeContainer,
  LessonLabelContainer,
  HeadingContainer,
  HeadingTextContainer,
  LessonNoteTypography,
  StyledNoteIcon };
